{
  "es": {
    "todo": {
      "actions": {
        "add": "Añadir tarea",
        "cancel": "Cancelar",
        "delete_todo": "Eliminar tarea",
        "edit": "Editar tarea",
        "save": "Guardar"
      },
      "attributes": {
        "active": "Activa",
        "assignee": "Responsable",
        "completed": "Completada",
        "description": "Descripción",
        "due_date": "Fecha límite",
        "title": "Título"
      },
      "labels": {
        "active": "activa",
        "allDone": "¡Todas las tareas están completadas!",
        "allTodos": "Todas las tareas",
        "completed": "completada",
        "filterTodos": "Filtrar tareas",
        "filters": "Filtros",
        "myTodos": "Mis tareas",
        "myTodosCount": "Mis tareas ({count})",
        "noActiveTodos": "No hay tareas activas",
        "noActiveTodosDashboard": "¡Enhorabuena, no tienes tareas pendientes!",
        "noCompletedYet": "Todavía no hay tareas completadas.",
        "noTodosCustomer": "¡Genial! No tienes ninguna tarea pendiente.",
        "selectAProjectFirst": "Selecciona primero un proyecto",
        "showLess": "Mostrar menos",
        "showOthers": "Mostrar más | Mostrar más ({count})"
      },
      "toasts": {
        "create": "Tarea creada",
        "delete": "Tarea eliminada",
        "update": "Tarea actualizada"
      },
      "validation": {
        "needtitle": "El título es obligatorio"
      }
    }
  }
}
